import React from "react";
import classes from "./ZipGameStepper.module.css";

const STEP_TITLES = ["Number", "Verify OTP", "User Details"];

const ZipGameStepper = ({ currentStep = 1 }) => {
  return (
    <div className={classes.stepperWrapper}>
      {STEP_TITLES.map((item, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep === stepNumber;
        const isCompleted = currentStep > stepNumber;

        return (
          <div className={classes.stepItem} key={item}>
            <div
              className={`${classes.stepCircle} ${
                isActive ? classes.stepCircleActive : ""
              } ${isCompleted ? classes.stepCircleCompleted : ""}`}
            >
              {stepNumber}
            </div>

            <p
              className={`${classes.stepLabel} ${
                isActive ? classes.stepLabelActive : ""
              } ${isCompleted ? classes.stepLabelCompleted : ""}`}
            >
              {item}
            </p>

            {index !== STEP_TITLES.length - 1 && (
              <div
                className={`${classes.stepLine} ${
                  currentStep > stepNumber ? classes.stepLineCompleted : ""
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ZipGameStepper;